<script setup lang="ts">
import RegroupementImmeubles from "@icons/building/regroupement_immeubles.svg?url"
import MaisonAppartement from "@icons/building/maison_appartement.svg?url"
import Appartement from "@icons/building/appartement.svg?url"
import MaisonPetite from "@icons/building/maison_petit.svg?url"
import Immeuble from "@icons/building/immeuble.svg?url"
import { computed } from "vue"

type Props = {
    /**
     * Type de l'icône à afficher.
     */
    type: string
    /**
     * Taille de l'icône à afficher.
     */
    size?: number
    /**
     * Si l'icône est secondaire.
     */
    secondary?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    type: "default",
    size: 24,
    secondary: false,
})

const getIconComposentByType = computed(() => {
    if (!props.type) return ""

    switch (props.type) {
        case "groupe":
            return RegroupementImmeubles
        case "maison_appartement":
            return MaisonAppartement
        case "appartement":
            return Appartement
        case "maison":
            return MaisonPetite
        case "immeuble":
        case "maison_immeuble":
            return Immeuble
        default:
            return Immeuble
    }
})
const getIconSize = computed(() => {
    return props.size
})
</script>

<template>
    <img
        class="base-building-icon"
        :style="{ width: `${getIconSize}px`, height: `${getIconSize}px` }"
        :src="getIconComposentByType"
        :width="getIconSize"
        :height="getIconSize"
    />
</template>
